import { AdminMavRow } from './admin-mav-row';

export { AdminMavRow };
